import { lazy } from "react";

export { VACANCIES_LIST_PATH } from "./vacancies-list-path";
export const VacanciesListPage = lazy(() => import("./vacancies-list"));
